export default "__VITE_ASSET__9ff6a0dc__"